(function () {
  'use strict';

  angular
    .module('pairingAssignmentComplementConfirmationModal')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('pairingAssignmentComplementConfirmationModal', {
        url: '/pairing-assignment-complement-confirmation-modal',
        views: {
          'pairingAssignmentComplementConfirmationModalView': {
            templateUrl: 'pairing-assignment-complement-confirmation-modal/views/pairing-assignment-complement-confirmation-modal.tpl.html',
            controller: 'pairingAssignmentComplementConfirmationModal',
            controllerAs: 'pairingAssignmentComplementConfirmationModal'
          }
        }
      });
  }
}());
